<!-- @Version: 1.0.3 --> 
@if (done$$() == true) {
  <div data-testid="emailcontainer" [formGroup]="fgEmail" class="row">
    <mat-form-field data-width="100%" [hideRequiredMarker]="hideRequireMaker">
      @if (fieldItem.attribute_1 && fieldItem.attribute_1 != '') {
        <mat-label data-testid="label" [innerHTML]="fieldItem.attribute_1!"></mat-label>
      }
      <input data-testid="input" matInput [required]="fieldItem.required! && !fgEmail.get(FC_EMAIL.EMAIL)?.disabled" [formControlName]="FC_EMAIL.EMAIL" [placeholder]="fieldItem.placeholder ?? ''">
      @if (fgEmail.get(FC_EMAIL.EMAIL)?.hasError(VALIDATORS.email)  || fgEmail.get(FC_EMAIL.EMAIL)?.hasError(VALIDATORS.pattern)) {
        <mat-error data-testid="errorPattern" [innerHTML]="error.errorCodePattern"></mat-error>
      }
      @else if (fgEmail.get(FC_EMAIL.EMAIL)?.hasError(VALIDATORS.required) && fgEmail.get(FC_EMAIL.EMAIL)?.touched ) {
        <mat-error data-testid="errorRequired" [innerHTML]="error.errorCodeRequired"></mat-error>
      }
    </mat-form-field>
  </div>
}
